<template>
  <section class="timeTplListAddAndEdit">
    <section class="viewTitle">
      <viewTitle
        v-if="$route.params.id"
        title="业务管理 / 车辆预约管理 / 预约时间模板 / 修改模板"
        :showReturn="true"
      />
      <viewTitle
        v-else
        title="业务管理 / 车辆预约管理 / 预约时间模板 / 新增模板"
        :showReturn="true"
      />
    </section>

    <div class="main">
      <el-form label-width="140px" style="width: 650px;">
        <el-form-item label="模板名称" required>
          <el-input
            v-model="timeTpObj.name"
            placeholder="请输入模板名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="有效时间范围" required>
          <div class="full100">
            <el-radio
              v-model="timeTpObj.timeType"
              label="1"
              class="elRadio1"
              @change="
                () => {
                  timeTpObj.timeRang = [];
                }
              "
              >永久有效</el-radio
            >
            <el-radio v-model="timeTpObj.timeType" label="2">自定义</el-radio>
            <el-date-picker
              :disabled="timeTypeDisable"
              v-model="timeTpObj.timeRang"
              type="daterange"
              value-format="yyyyMMdd"
              format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              class="w100"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="法定节假日" required>
          <el-radio v-model="timeTpObj.holidayType" label="2" class="elRadio1"
            >不使用</el-radio
          >
          <el-radio v-model="timeTpObj.holidayType" label="1"
            >自动根据法定节假日修正</el-radio
          >
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                所选择的日期会被剔除，不会生成预约号源，<br />
                且此项的运算权重比法定节假日、重复设置高。
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
            排除所选日期
          </div>
          <div class="c4b dayDiv">
            <template>
              <el-tag
                v-for="tag in timeTpObj.delDay"
                :key="tag"
                closable
                @close="() => delDelDay(index)"
              >
                {{ tag }}
              </el-tag>
            </template>
            <el-date-picker
              v-model="delDayTimePlugin"
              type="date"
              placeholder="选择日期"
              ref="delDayTimePlugin"
              prefix-icon="el-icon-plus"
              class="delDayTimePlugin"
              @blur="delDayTimePluginBlur"
            >
            </el-date-picker>
            <i class="el-icon-plus addDay" @click="addDelDay"></i>
          </div>
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                所选择的日期会被额外加入至“有效时间范围”内，<br />
                且此项的运算权重比法定节假日、重复设置高，<br />
                与“排除所选日期”权重相同。
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
            添加额外日期
          </div>
          <div class="c4b dayDiv">
            <template>
              <el-tag
                v-for="tag in timeTpObj.addDay"
                :key="tag"
                closable
                @close="() => delAddDay(index)"
              >
                {{ tag }}
              </el-tag>
            </template>
            <el-date-picker
              v-model="addDayTimePlugin"
              type="date"
              placeholder="选择日期"
              ref="addDayTimePlugin"
              prefix-icon="el-icon-plus"
              class="addDayTimePlugin"
              @blur="addDayTimePluginBlur"
            >
            </el-date-picker>
            <i class="el-icon-plus addDay" @click="addAddDay"></i>
          </div>
        </el-form-item>
        <el-form-item label="重复设置" required>
          <div>
            <el-checkbox-group v-model="timeTpObj.checkList">
              <el-checkbox label="1">周一</el-checkbox>
              <el-checkbox label="2">周二</el-checkbox>
              <el-checkbox label="3">周三</el-checkbox>
              <el-checkbox label="4">周四</el-checkbox>
              <el-checkbox label="5">周五</el-checkbox>
              <el-checkbox label="6">周六</el-checkbox>
              <el-checkbox label="0">周日</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="每日号源划分" required>
          <div class="c4b">
            <div class="sourceResult">
              <span class="desc">
                总号源数：
              </span>
              <span
                class="desc"
                v-if="
                  allSourceText1 === 0 &&
                    allSourceText2 === '存在不限号设置' &&
                    timeTpObj.daySource.length > 0
                "
              >
                不限号
              </span>
              <span class="desc" v-else>
                {{ allSourceText1 }}
                {{ allSourceText2 === "" ? "" : `(${allSourceText2})` }}
              </span>

              <template v-for="(item, index) in timeTpObj.daySource">
                <el-tag
                  :key="index"
                  @click="
                    () => {
                      editSource(item, index);
                    }
                  "
                  type="info"
                  closable
                  @close="
                    () => {
                      delDaySource(index);
                    }
                  "
                >
                  <span
                    >『 {{ item.begin_time }} 至 {{ item.end_time }} 』</span
                  >
                  <span
                    v-for="(group, index) in item.group_number"
                    :key="index"
                    style="margin-right: 10px;"
                  >
                    <span>{{ getGrouoName(group.group_id) }}</span>
                    <span
                      >({{
                        Number(group.number) == 0 ? "不限" : group.number
                      }})</span
                    >
                  </span>
                </el-tag>
              </template>
            </div>
            <i class="el-icon-plus addDay" @click="addSource"></i>
          </div>
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                此项是指用户发起车辆预约选择预约时间时，<br />
                必须提前多长时间。
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
            <span style="color: red;">*</span>
            最小可预约时间
          </div>
          <el-select
            v-model="timeTpObj.minRangKey"
            placeholder="请选择最小须提前多长时间发起预约"
          >
            <el-option
              v-for="item in timeTpObj.minRangList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                此项是指用户发起车辆预约选择预约时间时，<br />
                最大可提前多少天预约。
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
            <span style="color: red;">*</span>
            最大可预约时间
          </div>
          <el-select
            v-model="timeTpObj.maxRangKey"
            placeholder="请选择最大可发起多长时间内的预约"
          >
            <el-option
              v-for="item in timeTpObj.maxRangList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入备注（限500个字符）"
            v-model="timeTpObj.textarea"
          >
          </el-input>
        </el-form-item>
      </el-form>

      <div style="margin: 30px 0px 0px;">
        <el-popover
          style="margin-right: 20px;"
          placement="bottom-start"
          title="确认提醒"
          width="370"
          trigger="manual"
          v-model="timeTpObj.visible"
        >
          <template>
            <p>
              确认要{{
                $route.params.id ? "修改" : "创建"
              }}模板吗？确认前请先核实全部信息是否正确无误！
            </p>
            <div style="text-align: right; margin: 34px 0px 0px;">
              <el-button
                slot="reference"
                @click="timeTpObj.visible = false"
                size="small"
              >
                取 消
              </el-button>
              <el-button type="primary" @click="saveTmp" size="small">
                确 定
              </el-button>
            </div>
          </template>
          <el-button
            slot="reference"
            type="primary"
            @click="saveCheck"
            size="small"
          >
            {{ $route.params.id ? "确认修改" : "确认创建" }}
          </el-button>
        </el-popover>

        <!-- <el-button type="primary" @click="saveTmp">{{
          $route.params.id ? "确认修改" : "确认创建"
        }}</el-button> -->
      </div>

      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>模板名称：</span></el-col>
        <el-col :span="14">
          <el-input
            v-model="timeTpObj.name"
            placeholder="请输入内容"
          ></el-input>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>有效时间范围：</span></el-col>
        <el-col :span="14">
          <div class="full100">
            <el-radio
              v-model="timeTpObj.timeType"
              label="1"
              class="elRadio1"
              @change="
                () => {
                  timeTpObj.timeRang = [];
                }
              "
              >永久有效</el-radio
            >
            <el-radio v-model="timeTpObj.timeType" label="2">自定义</el-radio>
            <el-date-picker
              :disabled="timeTypeDisable"
              v-model="timeTpObj.timeRang"
              type="daterange"
              value-format="yyyyMMDD"
              format="yyyy-MM-DD"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              class="w100"
            >
            </el-date-picker>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>法定节假日：</span></el-col>
        <el-col :span="14">
          <el-radio v-model="timeTpObj.holidayType" label="1" class="elRadio1"
            >不使用</el-radio
          >
          <el-radio v-model="timeTpObj.holidayType" label="2"
            >自动根据法定节假日修正</el-radio
          >
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>排除日期：</span></el-col>
        <el-col :span="14">
          <div class="c4b dayDiv">
            <template>
              <el-tag
                v-for="tag in timeTpObj.delDay"
                :key="tag"
                closable
                @close="() => delDelDay(index)"
              >
                {{ tag }}
              </el-tag>
            </template>
            <el-date-picker
              v-model="delDayTimePlugin"
              type="date"
              placeholder="选择日期"
              ref="delDayTimePlugin"
              prefix-icon="el-icon-plus"
              class="delDayTimePlugin"
              @blur="delDayTimePluginBlur"
            >
            </el-date-picker>
            <i class="el-icon-plus addDay" @click="addDelDay"></i>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>添加额外日期：</span></el-col>
        <el-col :span="14">
          <div class="c4b dayDiv">
            <template>
              <el-tag
                v-for="tag in timeTpObj.addDay"
                :key="tag"
                closable
                @close="() => delAddDay(index)"
              >
                {{ tag }}
              </el-tag>
            </template>
            <el-date-picker
              v-model="addDayTimePlugin"
              type="date"
              placeholder="选择日期"
              ref="addDayTimePlugin"
              prefix-icon="el-icon-plus"
              class="addDayTimePlugin"
              @blur="addDayTimePluginBlur"
            >
            </el-date-picker>
            <i class="el-icon-plus addDay" @click="addAddDay"></i>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>重复设置：</span></el-col>
        <el-col :span="14">
          <div>
            <el-checkbox-group v-model="timeTpObj.checkList">
              <el-checkbox label="1">星期一</el-checkbox>
              <el-checkbox label="2">星期二</el-checkbox>
              <el-checkbox label="3">星期三</el-checkbox>
              <el-checkbox label="4">星期四</el-checkbox>
              <el-checkbox label="5">星期五</el-checkbox>
              <el-checkbox label="6">星期六</el-checkbox>
              <el-checkbox label="0">星期日</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>每日号源划分：</span></el-col>
        <el-col :span="14">
          <div class="c4b">
            <div class="sourceResult">
              <span class="desc"
                >总号源树：{{ allSourceText1 }}(<span>{{ allSourceText2 }}</span
                >)</span
              >
              <template v-for="(item, index) in timeTpObj.daySource">
                <el-tag
                  :key="index"
                  @click="
                    () => {
                      editSource(item, index);
                    }
                  "
                  type="info"
                  closable
                  @close="
                    () => {
                      delDaySource(index);
                    }
                  "
                >
                  <div>{{ item.begin_time }} ~ {{ item.end_time }}</div>
                  <span
                    v-for="(group, index) in item.group_number"
                    :key="index"
                  >
                    <span>{{ getGrouoName(group.group_id) }}</span>
                    <span
                      >({{
                        Number(group.number) == 0 ? "不限" : group.number
                      }})</span
                    >
                  </span>
                </el-tag>
              </template>
            </div>
            <i class="el-icon-plus addDay" @click="addSource"></i>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>最小可预约时间：</span></el-col>
        <el-col :span="14">
          <el-select
            v-model="timeTpObj.minRangKey"
            placeholder="请选择最小可预约时间"
          >
            <el-option
              v-for="item in timeTpObj.minRangList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>最大可预约时间：</span></el-col>
        <el-col :span="14">
          <el-select
            v-model="timeTpObj.maxRangKey"
            placeholder="请选择最大可预约时间"
          >
            <el-option
              v-for="item in timeTpObj.maxRangList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"><span>备注：</span></el-col>
        <el-col :span="14">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入备注"
            v-model="timeTpObj.textarea"
          >
          </el-input>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="4"></el-col>
        <el-col :span="10">
          <el-button type="primary" @click="saveTmp">{{
            $route.params.id ? "确认修改" : "确认创建"
          }}</el-button>
          <el-button @click="backList">返回</el-button>
        </el-col>
      </el-row> -->
    </div>
    <el-dialog
      :title="$route.params.id ? '修改每日号源划分' : '添加每日号源划分'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="670px"
      class="elDialog"
    >
      <div>
        <el-row type="flex" align="middle" :gutter="20">
          <el-col :span="4">
            <span style="color: red;">*</span>
            <span>时间段</span>
          </el-col>
          <el-col :span="20">
            <el-time-picker
              is-range
              v-model="sourceobj.timeRang"
              value-format="HH:mm"
              format="HH:mm"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
            >
            </el-time-picker>
          </el-col>
        </el-row>
        <template v-for="(business, index) in sourceobj.businessArr">
          <el-row :key="index" type="flex" align="middle" :gutter="20">
            <el-col :span="4">
              <span style="color: red;">*</span>
              <span v-if="Number(index) == 0">业务组设置</span>
            </el-col>
            <el-col :span="20">
              <div class="divRow">
                <el-select
                  v-model="business.opKey"
                  clearable
                  placeholder="请选择业务组"
                  @change="
                    val => {
                      opKeyChange();
                    }
                  "
                >
                  <el-option
                    v-show="sourceobj.opKeyList.indexOf(item.id) < 0"
                    v-for="item in businessList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-radio
                  label="1"
                  v-model="business.timeType"
                  class="elRadio1"
                  @change="
                    () => {
                      business.sum = '';
                    }
                  "
                  >数量不限</el-radio
                >
                <el-radio label="2" v-model="business.timeType" class="elRadio1"
                  >限定数量</el-radio
                >
                <el-input
                  v-if="Number(business.timeType) == 2"
                  v-model="business.sum"
                  placeholder="数量"
                ></el-input>
                <el-input
                  disabled
                  v-else
                  v-model="business.sum"
                  placeholder="数量"
                ></el-input>
                <i
                  class="el-icon-close close"
                  @click="
                    () => {
                      businessDel(index);
                    }
                  "
                ></i>
              </div>
            </el-col>
          </el-row>
        </template>
        <el-row type="flex" align="middle" :gutter="20">
          <el-col :span="4">
            <span v-if="sourceobj.businessArr.length == 0">业务组设置</span>
          </el-col>
          <el-col :span="20">
            <div class="divRow">
              <i class="el-icon-plus plus" @click="businessAdd"></i>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="comfireSourceobj" size="small">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import viewTitle from "@/components/viewTitle";
import moment from "moment";
export default {
  props: {},
  data() {
    return {
      timeTpObj: {
        visible: false,
        name: "",
        timeType: "",
        timeRang: [],
        delDay: [],
        addDay: [],
        checkList: [],
        holidayType: "",
        minRangList: [
          {
            value: "3600",
            label: "不小于1小时(推荐)"
          },
          {
            value: "7200",
            label: "不小于2小时"
          },
          {
            value: "10800",
            label: "不小于3小时"
          },
          {
            value: "14400",
            label: "不小于4小时"
          },
          {
            value: "18000",
            label: "不小于5小时"
          }
        ],
        maxRangList: [
          {
            value: "1",
            label: "1天内"
          },
          {
            value: "2",
            label: "2天内"
          },
          {
            value: "3",
            label: "3天内"
          },
          {
            value: "7",
            label: "7天内(推荐)"
          },
          {
            value: "15",
            label: "15天内"
          },
          {
            value: "30",
            label: "30天内"
          }
        ],
        options: [],
        textarea: "",
        minRangKey: "",
        maxRangKey: "",
        daySource: []
      },
      dialogVisible: false,
      businessList: [],
      sourceobj: {
        timeRang: ["08:00", "09:00"],
        opKeyList: [],
        businessArr: [
          {
            opKey: "",
            timeType: "",
            sum: ""
          }
        ],
        index: ""
      },
      delDayTimePlugin: "",
      addDayTimePlugin: "",
      allSourceText1: 0,
      allSourceText2: ""
    };
  },
  watch: {},
  components: { viewTitle },
  computed: {
    getGrouoName() {
      return id => {
        for (let i = 0; i < this.businessList.length; i++) {
          let item = this.businessList[i];
          if (id == item.id) {
            return item.name;
          }
        }
      };
    },
    timeTypeDisable() {
      console.log("12323423");
      return this.timeTpObj.timeType == "2" ? false : true;
    }
    // allSourceText1() {
    //   let t1 = 0;
    //   this.timeTpObj.daySource.forEach(item => {
    //     item.group_number.forEach(item1 => {
    //       t1 += Number(item1.number);
    //     });
    //   });
    //   return t1;
    // },
    // allSourceText2() {
    //   let t2 = "";
    //   this.timeTpObj.daySource.forEach(item => {
    //     item.group_number.forEach(item1 => {
    //       if (Number(item1.number) == 0) {
    //         t2 = "存在不限号设置";
    //       }
    //     });
    //   });
    //   return t2;
    // }
  },
  methods: {
    getInitData(id) {
      this.$common
        .http({
          url: "/api/queue/admin/query_business_time_model_detail",
          data: {
            id
          }
        })
        .then(res => {
          console.log(res);
          const data = res.data.data;
          this.timeTpObj.name = data.name;
          this.timeTpObj.timeType = data.is_permanent_valid.toString();
          if (data.is_permanent_valid.toString() == "2") {
            this.timeTpObj.timeRang = [
              data.begin_time.toString(),
              data.end_time.toString()
            ];
          } else {
            this.timeTpObj.timeRang = [];
          }
          this.timeTpObj.holidayType = data.is_use_statutory_holidays.toString();
          this.timeTpObj.addDay = data.exclude_day;
          this.timeTpObj.delDay = data.extra_day;
          this.timeTpObj.checkList = data.repeat_setting;
          this.timeTpObj.minRangKey = data.min_booking_time.toString();
          this.timeTpObj.maxRangKey = data.max_booking_day.toString();
          this.timeTpObj.textarea = data.note;
          this.timeTpObj.daySource = data.periods;
          this.setAllSource();
        });
    },
    getBusinessList() {
      this.$common
        .http({
          url: "/api/queue/admin/query_business_group",
          data: {
            keyword: "",
            state: 1,
            page_size: 1000
          }
        })
        .then(res => {
          this.businessList = res.data.data.data;
        });
    },
    addDelDay() {
      this.$refs["delDayTimePlugin"].focus();
    },
    delDayTimePluginBlur(time) {
      if (time.value === "") {
        return false;
      }
      let timeVal = moment(time.value).format("YYYY-MM-DD");
      if (this.timeTpObj.delDay.indexOf(timeVal) < 0) {
        this.timeTpObj.delDay.push(timeVal);
      }
    },
    addAddDay() {
      this.$refs["addDayTimePlugin"].focus();
    },
    addDayTimePluginBlur(time) {
      if (time.value === "") {
        return false;
      }
      let timeVal = moment(time.value).format("YYYY-MM-DD");
      if (this.timeTpObj.addDay.indexOf(timeVal) < 0) {
        this.timeTpObj.addDay.push(timeVal);
      }
      this.delDayTimePlugin = "";
    },
    delDelDay(index) {
      this.timeTpObj.delDay.splice(index, 1);
    },
    delAddDay(index) {
      this.timeTpObj.addDay.splice(index, 1);
    },
    addSource() {
      this.dialogVisible = true;
      this.sourceobj.timeRang = ["08:00", "09:00"];
      this.sourceobj.opKeyList = [];
      this.sourceobj.businessArr = [
        {
          opKey: "",
          timeType: "",
          sum: ""
        }
      ];
      this.sourceobj.index = "";
    },
    businessDel(index) {
      this.sourceobj.businessArr.splice(index, 1);
      this.opKeyChange();
    },
    businessAdd() {
      this.sourceobj.businessArr.push({
        opKey: "",
        timeType: "",
        sum: ""
      });
    },
    opKeyChange() {
      let opKeyList = [];
      this.sourceobj.businessArr.forEach(item => {
        opKeyList.push(item.opKey);
      });
      this.sourceobj.opKeyList = [...new Set(opKeyList)];
    },
    comfireSourceobj() {
      let groupNumber = [];
      for (let i = 0; i < this.sourceobj.businessArr.length; i++) {
        let item = this.sourceobj.businessArr[i];
        if (item.opKey.trim() === "") {
          this.$common.pcToastFail(`请选择第${i + 1}项的业务组`);
          return false;
        }
        if (item.timeType.trim() === "") {
          this.$common.pcToastFail(`请选择第${i + 1}项的业务组数量设置方式`);
          return false;
        }
        if (Number(item.timeType) === 2) {
          if (item.sum === "") {
            this.$common.pcToastFail(`第${i + 1}项的限定数量不能为空`);
            return false;
          }
          if (!Number(item.sum) && Number(item.sum) !== 0) {
            this.$common.pcToastFail(`第${i + 1}项的限定数量不能为非数字值`);
            return false;
          }
          if (String(item.sum).indexOf(".") > 0) {
            this.$common.pcToastFail(`第${i + 1}项的限定数量必须为正整数`);
            return false;
          }
          if (Number(item.sum) < 1 || Number(item.sum) > 999) {
            this.$common.pcToastFail(`第${i + 1}项的限定数量范围为1~999`);
            return false;
          }
        }
      }
      console.log("nihao ");
      this.dialogVisible = false;
      this.sourceobj.businessArr.forEach(item => {
        groupNumber.push({
          group_id: item.opKey,
          number: Number(item.timeType) == 1 ? 0 : item.sum
        });
      });
      let daySource = {
        begin_time: this.sourceobj.timeRang[0],
        end_time: this.sourceobj.timeRang[1],
        group_number: groupNumber
      };
      daySource = JSON.parse(JSON.stringify(daySource));
      if (this.sourceobj.index.toString().length > 0) {
        this.timeTpObj.daySource[Number(this.sourceobj.index)] = daySource;
      } else {
        this.timeTpObj.daySource.push(daySource);
      }
      this.setAllSource();
    },
    setAllSource() {
      // 总号源数
      let t1 = 0;
      this.timeTpObj.daySource.forEach(item => {
        item.group_number.forEach(item1 => {
          t1 += Number(item1.number);
        });
      });
      this.allSourceText1 = t1;
      // 是否存在不限号设置
      let t2 = "";
      this.timeTpObj.daySource.forEach(item => {
        item.group_number.forEach(item1 => {
          if (Number(item1.number) == 0) {
            t2 = "存在不限号设置";
          }
        });
      });
      this.allSourceText2 = t2;
    },
    editSource(item, index) {
      this.dialogVisible = true;
      this.sourceobj.opKeyList = [];
      this.sourceobj.businessArr = [];
      this.sourceobj.timeRang = [item.begin_time, item.end_time];
      item.group_number.forEach(group => {
        this.sourceobj.opKeyList.push(group.group_id);
        this.sourceobj.businessArr.push({
          opKey: group.group_id,
          timeType: Number(group.number) == 0 ? "1" : "2",
          sum: Number(group.number) > 0 ? group.number : ""
        });
      });
      this.sourceobj.index = index;
    },
    delDaySource(index) {
      this.timeTpObj.daySource.splice(index, 1);
      this.setAllSource();
    },
    saveCheck() {
      if (this.timeTpObj.name.trim() === "") {
        this.$common.pcToastFail(`请输入模板名称`);
        return false;
      }
      if (this.timeTpObj.timeType.trim() === "") {
        this.$common.pcToastFail(`请选择有效时间范围`);
        return false;
      }
      if (
        Number(this.timeTpObj.timeType.trim()) === 2 &&
        this.timeTpObj.timeRang.length !== 2
      ) {
        this.$common.pcToastFail(`请设置有效时间的自定义范围`);
        return false;
      }
      if (this.timeTpObj.holidayType.trim() === "") {
        this.$common.pcToastFail(`请选择是否使用自动根据法定节假日修正`);
        return false;
      }
      if (this.timeTpObj.checkList.length === 0) {
        this.$common.pcToastFail(`至少选择一个重复设置的时间`);
        return false;
      }
      if (this.timeTpObj.daySource.length === 0) {
        this.$common.pcToastFail(`请设置每日号源划分`);
        return false;
      }
      if (this.timeTpObj.minRangKey.trim() === "") {
        this.$common.pcToastFail(`请选择最小可预约时间`);
        return false;
      }
      if (this.timeTpObj.maxRangKey.trim() === "") {
        this.$common.pcToastFail(`请选择最大可预约时间`);
        return false;
      }
      this.timeTpObj.visible = true;
    },
    saveTmp() {
      this.timeTpObj.visible = false;
      let data = {
        id: this.$route.params.id || "",
        name: this.timeTpObj.name,
        is_permanent_valid: Number(this.timeTpObj.timeType),
        begin_time: this.timeTpObj.timeRang[0] || "",
        end_time: this.timeTpObj.timeRang[1] || "",
        is_use_statutory_holidays: Number(this.timeTpObj.holidayType),
        exclude_day: JSON.stringify(this.timeTpObj.addDay),
        extra_day: JSON.stringify(this.timeTpObj.delDay),
        repeat_setting: JSON.stringify(this.timeTpObj.checkList),
        min_booking_time: this.timeTpObj.minRangKey,
        max_booking_day: this.timeTpObj.maxRangKey,
        note: this.timeTpObj.textarea,
        period_number: JSON.stringify(this.timeTpObj.daySource)
      };
      console.log(data);
      this.$common
        .http({
          url: "/api/queue/admin/save_business_time_model",
          data: data
        })
        .then(res => {
          if (this.$route.params.id) {
            this.$common.pcToastSuccess("修改成功");
            this.$router.push({
              path: "/rhqy/service/appoint/timeTplList/detail/" + res.data.data
            });
          } else {
            this.$common.pcToastSuccess("创建成功");
            this.$router.push({
              path: "/rhqy/service/appoint/timeTplList"
            });
          }
          // this.$router.go(-1);
        });
    },
    backList() {
      this.$router.go(-1);
    }
  },
  created() {
    this.getBusinessList();
    if (this.$route.params.id) {
      this.getInitData(this.$route.params.id);
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.timeTplListAddAndEdit {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  .main {
    padding: 16px;
    .el-row {
      padding-bottom: 18px;
    }
    .el-col-4 {
      text-align: right;
    }
    .elRadio1 {
      width: 70px;
    }
    .el-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .addDay {
      color: #409eff;
      font-size: 20px;
      cursor: pointer;
      height: 25px;
    }
    .c4b {
      padding: 5px 10px 0px 10px;
      border: 1px solid #cecece;
    }
    .full100 {
      display: flex;
      align-items: baseline;
      margin-top: 4px;
      .w100 {
        width: 100%;
      }
    }
    .dayDiv {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .el-select {
      width: 100%;
    }
    .sourceResult {
      .desc {
        display: inline-block;
      }
      .el-tag {
        display: inline-block;
        white-space: normal;
        height: auto;
        line-height: 17px;
        padding: 5px 28px 5px 8px;
        position: relative;
        width: 100%;
      }
    }
  }
  .elDialog {
    .el-row {
      padding-bottom: 18px;
    }
    .divRow {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .el-radio {
        margin-right: 10px;
      }
      .el-select {
        width: 200px;
        margin-right: 10px;
      }
      .el-input {
        width: 100px;
        margin-right: 10px;
      }
    }
    .el-col-4 {
      text-align: right;
    }
    .plus {
      color: #409eff;
      cursor: pointer;
    }
    .close {
      color: coral;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less">
.timeTplListAddAndEdit {
  .el-date-editor .el-range-separator {
    line-height: 24px;
  }
  .sourceResult {
    .el-tag {
      .el-icon-close {
        right: 8px;
        top: 50%;
        transform: translate(0, -50%);
        position: absolute;
      }
    }
  }
  .delDayTimePlugin,
  .addDayTimePlugin {
    width: 0;
    opacity: 0;
    > input {
      border: 0 !important;
      padding: 0;
    }
  }
}
</style>
